export default function Recipients() {
  const recipients = [
    {
      icon: 'ri-shield-check-line',
      title: 'Ahli PBPKNM Berdaftar',
      description: 'Ahli yang berdaftar secara sah dengan PBPKNM dan layak menerima bantuan',
      color: 'emerald'
    },
    {
      icon: 'ri-hand-coin-line',
      title: 'Golongan Berpendapatan Rendah',
      description: 'Bekas anggota yang memerlukan sokongan kewangan untuk keperluan asas',
      color: 'amber'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Memerlukan Bantuan Kebajikan',
      description: 'Bekas anggota keselamatan yang memerlukan bantuan kebajikan berterusan',
      color: 'rose'
    }
  ];

  return (
    <section id="sasaran" className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-gradient-to-b from-emerald-50 to-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-700 px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
            <i className="ri-group-line"></i>
            Sasaran Penerima
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 sm:mb-6 px-4">
            🤝 Sasaran Penerima
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Kempen ini menyasarkan bekas wira negara yang telah berkhidmat dan kini memerlukan sokongan
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {recipients.map((recipient, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className={`w-12 h-12 sm:w-16 sm:h-16 bg-${recipient.color}-100 rounded-2xl flex items-center justify-center mb-4 sm:mb-6 mx-auto`}>
                <i className={`${recipient.icon} text-2xl sm:text-3xl text-${recipient.color}-600`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-3 sm:mb-4 text-center">
                {recipient.title}
              </h3>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed text-center">
                {recipient.description}
              </p>
            </div>
          ))}
        </div>

        {/* Hero Image Section */}
        <div className="grid md:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div className="relative">
            <div className="w-full h-64 sm:h-80 lg:h-96 rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/3294a4af19582454411e375cbd1c78be/c6c7c772b6b5e709dc32026b846d0723.png"
                alt="Bekas Anggota Keselamatan"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="space-y-4 sm:space-y-6">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-800">
              Menghargai Jasa Wira Negara
            </h3>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              Bekas anggota pasukan keselamatan negara telah berkhidmat dengan penuh dedikasi untuk menjaga keamanan dan kedaulatan Malaysia. Kini tiba masanya untuk kita membalas jasa mereka.
            </p>

            <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-2xl p-4 sm:p-6 border-l-4 border-emerald-600">
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-medium">
                "Setiap sumbangan anda adalah tanda penghargaan kepada pengorbanan dan dedikasi mereka dalam menjaga negara tercinta."
              </p>
            </div>

            <div className="grid grid-cols-2 gap-3 sm:gap-4">
              <div className="bg-white rounded-xl p-4 sm:p-5 shadow-md border border-gray-100">
                <i className="ri-medal-line text-2xl sm:text-3xl text-amber-600 mb-2 sm:mb-3"></i>
                <div className="text-xs sm:text-sm text-gray-500 mb-1">Status</div>
                <div className="text-sm sm:text-base font-bold text-gray-800">Bekas Wira Negara</div>
              </div>
              <div className="bg-white rounded-xl p-4 sm:p-5 shadow-md border border-gray-100">
                <i className="ri-shield-star-line text-2xl sm:text-3xl text-emerald-600 mb-2 sm:mb-3"></i>
                <div className="text-xs sm:text-sm text-gray-500 mb-1">Kelayakan</div>
                <div className="text-sm sm:text-base font-bold text-gray-800">Ahli PBPKNM</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
